<template>
  <el-dialog title="选择收藏夹" :visible.sync="visible" width="500px">
    <div class="collect-modal" v-loading="initLoading" ref="collectModalRef">
      <div class="collect-editor" v-if="editor.visible">
        <el-input v-model.trim="editor.word" placeholder="请输入收藏夹名称" maxlength="20" />
        <div class="collect-editor-tools" :style="{ textAlign: 'right', marginTop: '20px' }">
          <el-button @click="closeEditorHandle()">取 消</el-button>
          <el-button type="primary" :loading="editor.loading" @click="groupConfirmHandle">确 定</el-button>
        </div>
      </div>
      <div class="collect-content" v-else>
        <div class="collect-empty-content" v-if="isEmpty">
          <img class="collect-empty-img" :src="emptyImg" />
          <div class="collect-empty-text">暂无收藏夹</div>
          <el-button plain :style="{ height: '32px', padding: '0 15px 2px' }" @click="editor.init()">
            <img :src="createImg" :style="{ width: '14px', marginRight: '4px', position: 'relative', top: '1px' }" />
            <span>新建收藏夹</span>
          </el-button>
        </div>
        <div class="group-ul" v-else>
          <el-input
            v-model="searchKeyword"
            placeholder="请输入收藏夹名称搜索"
            clearable
            :style="{ marginBottom: '10px' }"
          />
          <div
            class="group-li"
            v-for="groupItem in groupList"
            :key="groupItem.id"
            :class="curGroup === groupItem && 'is-active'"
            @click="curGroup = groupItem"
            v-show="!searchKeyword || groupItem.groupName.includes(searchKeyword)"
          >
            <img class="group-folder" :src="folderImg" />
            <div class="group-text">
              <div class="group-name single-ellipsis">{{ groupItem.groupName }}</div>
              <div class="group-count">({{ groupItem.doc_count || 0 }})</div>
            </div>
            <div class="group-tools">
              <i class="el-icon-edit-outline group-tool-icon" @click.stop="editor.init(groupItem)"></i>
              <i class="el-icon-delete group-tool-icon" @click.stop="delGroupHandle(groupItem)"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" v-if="!editor.visible && !isEmpty">
      <el-button plain :style="{ float: 'left', height: '32px', padding: '0 15px 2px' }" @click="editor.init()">
        <img :src="createImg" :style="{ width: '14px', marginRight: '4px', position: 'relative', top: '1px' }" />
        <span>新建收藏夹</span>
      </el-button>
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="confirmHandle">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import createImg from '@/assets/img/新建文件@2x.png';
import emptyImg from '@/assets/img/暂无收藏夹@2x.png';
import folderImg from '@/assets/img/multi-report-cur.png';
import { services } from '@/service';

export default {
  data() {
    return {
      createImg,
      emptyImg,
      folderImg,
      initLoading: false,
      groupList: [],
      searchKeyword: '',
      isUpdGroup: false,
      curGroup: null,
      editor: {
        visible: false,
        word: '',
        groupDetail: null,
        loading: false,
        init: function(groupDetail = null) {
          this.visible = true;
          this.groupDetail = groupDetail;
          if (groupDetail) {
            this.word = groupDetail.groupName;
          } else {
            this.word = '';
          }
          this.loading = false;
        }
      },
      loading: false
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    courseId: {
      type: String,
      required: true
    },
    detail: {
      type: Object,
      required: true
    }
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        if (!val) {
          if (this.isUpdGroup) {
            this.$emit('refreshGroup');
          }
          this.$emit('update:show', val);
        }
      }
    },
    isEmpty() {
      return this.groupList.length < 1 && !this.initLoading;
    }
  },
  mounted() {
    this.initHandle();
  },
  methods: {
    async initHandle() {
      try {
        this.initLoading = true;
        this.groupList = await services.courseware.getCollectGroup(this.courseId);
      } catch (err) {
        this.$error(err);
      } finally {
        this.initLoading = false;
      }
    },
    closeEditorHandle() {
      if (!this.editor.loading) {
        this.editor.visible = false;
      }
    },
    async groupConfirmHandle() {
      const { word, groupDetail } = this.editor;
      if (!word) {
        this.$message.warning('请输入收藏夹名称');
        return;
      }
      try {
        this.editor.loading = true;
        let result = null;
        if (groupDetail) {
          result = await services.courseware.updCollectGroup({
            coursewareId: this.courseId,
            op_type: 'update',
            groupId: groupDetail.id,
            groupName: word
          });
          this.$message.success('修改成功');
          const idx = this.groupList.findIndex(o => o.id === groupDetail.id);
          this.groupList.splice(idx, 1, result);
        } else {
          result = await services.courseware.updCollectGroup({
            coursewareId: this.courseId,
            op_type: 'add',
            groupName: word
          });
          this.$message.success('创建成功');
          this.groupList.push(result);
          this.$refs.collectModalRef.scrollTop = 99999;
        }
        if (!word.includes(this.searchKeyword)) {
          this.searchKeyword = '';
        }
        this.editor.visible = false;
        this.curGroup = result;
        this.isUpdGroup = true;
      } catch (err) {
        this.$error(err);
      } finally {
        this.editor.loading = false;
      }
    },
    delGroupHandle(groupDetail) {
      this.$confirm(`删除收藏夹后会同时解除该收藏夹下的关联案件，是否确认继续删除？`, '操作提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: async (action, instance, done) => {
          if (action !== 'confirm') {
            done();
            return;
          }
          try {
            instance.confirmButtonLoading = true;
            await services.courseware.updCollectGroup({
              coursewareId: this.courseId,
              op_type: 'del',
              groupId: groupDetail.id
            });
            this.$message.success('删除成功');
            const idx = this.groupList.findIndex(o => o === groupDetail);
            if (idx !== -1) {
              this.groupList.splice(idx, 1);
            }
            if (groupDetail === this.curGroup) {
              this.curGroup = null;
            }
            this.isUpdGroup = true;
            done();
          } catch (err) {
            this.$error(err);
          } finally {
            instance.confirmButtonLoading = false;
          }
        }
      });
    },
    async confirmHandle() {
      if (!this.curGroup) {
        this.$message.warning('请先选择收藏夹');
        return;
      }
      try {
        this.loading = true;
        await services.courseware.collect(this.courseId, this.detail.caseId, this.curGroup.id);
        this.$emit('success', this.detail);
        this.visible = false;
      } catch (err) {
        this.$error(err);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.collect-modal {
  min-height: 280px;
  max-height: 580px;
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  .collect-content {
    .collect-empty-content {
      text-align: center;
      padding: 60px;

      .collect-empty-img {
        width: 68px;
        height: 41px;
      }
      .collect-empty-text {
        color: #9599a5;
        font-size: 14px;
        line-height: 20px;
        margin: 10px 0 26px;
      }
    }

    .group-ul {
      .group-li {
        display: flex;
        align-items: center;
        height: 32px;
        cursor: pointer;

        .group-folder {
          width: 18px;
          height: 18px;
          margin-right: 10px;
        }

        .group-text {
          flex: 1;
          width: 0;
          color: #2c3443;
          font-size: 14px;
          line-height: 20px;
          display: flex;
          align-items: center;

          .group-count {
            flex-shrink: 0;
            color: #9599a5;
          }
        }
        .group-tools {
          opacity: 0;
          .group-tool-icon {
            color: #9599a5;
            font-size: 14px;
            padding: 5px;
            padding-right: 0;
            cursor: pointer;
            margin-right: 4px;
          }
        }

        &.is-active {
          background-color: #f1f8fd;
        }

        &:hover {
          .group-tools {
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
